import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TableActionEvent, TableParams, TableRow} from '../../../../shared';

import {PageEvent} from "@angular/material/paginator";
import {
  CHACRASTABLE_COLUMNS_ACTIONS_DEFAULT,
  CHACRASTABLE_COLUMNS_DATA_DEFAULT,
  ChacrasTableColumn,
  ChacrasTableParams, createChacrasTableRow
} from "../../../models/chacra";

@Component({
  selector: 'app-chacra-table',
  templateUrl: './chacra-table.component.html',
  styleUrls: ['./chacra-table.component.scss']
})
export class ChacraTableComponent {
  // aux
  columns: ChacrasTableColumn[] = [];
  rows: TableRow[] = [];
  // output
  @Output() actioned = new EventEmitter<TableActionEvent>();
  @Output() paginationChange = new EventEmitter<PageEvent>();
  tableParams: TableParams = {
    columns: [],
    values: []
  };
  // search outside
  @Input() filterText: string = null;

  constructor() {
  }

  // input
  protected _params: ChacrasTableParams = null;

  get params(): ChacrasTableParams {
    return this._params;
  }

  @Input()
  set params(params: ChacrasTableParams) {
    this._params = params;
    this.update();
  }

  update() {
    this.columns = [];
    this.rows = [];
    this.columns = this.params.columns || {...CHACRASTABLE_COLUMNS_DATA_DEFAULT, ...CHACRASTABLE_COLUMNS_ACTIONS_DEFAULT};
    this.updateRows();
    this.tableParams = {
      columns: this.columns.map(c => ({...c})),
      values: this.rows.map(r => ({...r})),
      filter: this.params.filter,
      pagination: this.params.pagination,
      ajaxPagination: this.params.ajaxPagination,
      sortTypes: this.params.sortTypes,
    };
  }

  updateRows() {
    const rows: TableRow[] = [];
    if (this.params.chacras) {
      for (const chacra of this.params.chacras) {
        rows.push(createChacrasTableRow(chacra, this.columns, this.params.sources));
      }
    }
    this.rows = rows;
  }

  emit(action: TableActionEvent) {
    this.actioned.emit(action);
  }

  emitPaginationChange(pageEvent: PageEvent) {
    this.paginationChange.emit(pageEvent);
  }
}
